const MockData = [
  {
    code: 'G0000697',
    stock: {
      stockLevel: 500,
      stockLevelStatus: 'inStock'
    }
  },
  {
    code: 'G0000692',
    stock: {
      stockLevel: 500,
      stockLevelStatus: 'inStock'
    }
  },
  {
    code: 'G0000717',
    stock: {
      stockLevel: 0,
      stockLevelStatus: 'outOfStock'
    }
  },
  {
    code: 'G0000722',
    stock: {
      stockLevel: 10,
      stockLevelStatus: 'lowStock'
    }
  }
]

export default MockData
